function setIsNewOptionAsFalse(item) {
  return item && item.isNewOption !== undefined
    ? { ...item, isNewOption: false }
    : item;
}

export default setIsNewOptionAsFalse;
